
import { supabase } from '@/lib/supabase';
import { Bot, BotStatus } from '@/types/trader';

export const fetchBotDetails = async (botId: string, userId: string): Promise<Bot | null> => {
  const { data, error } = await supabase
    .from('bots')
    .select('*')
    .eq('id', botId)
    .eq('owner_id', userId)
    .single();
  
  if (error) throw error;
  return data;
};

export const updateBotStatus = async (botId: string, newStatus: BotStatus): Promise<void> => {
  const { error } = await supabase
    .from('bots')
    .update({ status: newStatus })
    .eq('id', botId);
    
  if (error) throw error;
};

export const deleteBot = async (botId: string): Promise<void> => {
  const { error } = await supabase
    .from('bots')
    .delete()
    .eq('id', botId);
    
  if (error) throw error;
};
